import { elk } from '../report';
/**
 * 最纯净的请求
 */
let axios = null;
import qs from 'qs';

const _decode16 = str => {
    return str.replace(/\\x(\w{2})/g, function (_, $1) {
        return String.fromCharCode(parseInt($1, 16));
    });
};

function isEmpty(obj) {
  return obj != null && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
}

export function init(_axios) {
    axios = _axios;
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    axios.defaults.transformRequest = [function (data, headers) {
        return qs.stringify(data);
    }];
    axios.defaults.transformResponse = [function (data) {
        try {
            data = _decode16(data);
            data = data.replace(/\n/g, '');
            data = JSON.parse(data);
        } catch (e) {
            data = {};
        }
        return data;
    }];
    // 响应处理transformResponse优先级高于响应拦截器axios.interceptors.response
    // 请求拦截器 -> 请求数据转换 -> 响应数据转换 -> 响应拦截器
    axios.interceptors.response.use(function (response) {
      try {
        // 如果后台有返回数据，且转换后的 json 值为空字符串或者空对象，则说明后台返回有问题
        if (response.request.responseText !== '' && (response.data === '' || isEmpty(response.data))) {
          const { config, request } = response;
          const { method, data, url } = config; // 请求
          const { responseText } = request; // 响应
          // 请求响应有值，但是解析成了空字符串，则说明axios尝试解析失败
          elk({
            key: "AjaxJsonParseError",
            method: method,
            url: url,
            str4: data,
            msg: responseText,
          });
        }
      } catch (e) {}
      return response;
    });
}

export function get() {
    if (!axios) {
        throw new Error('axios is not defined!');
    }
    return axios.get.apply(axios, arguments);
}

export function post() {
    if (!axios) {
        throw new Error('axios is not defined!');
    }
    return axios.post.apply(axios, arguments);
}


export function getPureInstance() {
    const pureAxios = axios.create({
        transformRequest: [],
        transformResponse: [],
    });
    return pureAxios;
}